import React from "react";
import { modal } from "../modal";

export const modal_threed_view = props => {
  const { iframeUrl } = props;
  return (
    <div className="modal_threed_view modal_base">
      <div className="cross" onClick={() => modal.closeModal()} />
      <div className="img_container">
        <iframe
          frameBorder="0"
          scrolling="no"
          src={iframeUrl}
          allowFullScreen="true"
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/modal/modal_threed_view.jsx